<template>
    <b-tooltip :target="`tag-${profileId}`" triggers="hover">
        <!-- <template v-if="isPrimaryEA && isDefault">
            Only admin can remove Primary EA
        </template> -->
        
        <template v-if="isSecondaryEA && isDefault">
            Only admin can remove Primary EA
        </template>

        <!-- the logged user is a secondary EA of this customer -->
        <template v-else-if="isSecondaryEA && profileUserId === profileId && !isDefault">
            <template v-if="openTaskCount + openHandoverCount > 0">
                EA has open tasks or handover requests
            </template>
            <template v-else> </template>
        </template>

        <template v-else-if="isSecondaryEA && !isDefault">
            Only admin or primary EA can remove another EA
        </template>
        
        <template v-else-if="openTaskCount + openHandoverCount > 0">
            EA has open tasks or handover requests
        </template>
    </b-tooltip>
</template>

<script>
export default {
    props: [
        "isPrimaryEA",
        "isSecondaryEA",
        "isDefault",
        "profileUserId",
        "profileId",
        "openTaskCount",
        "openHandoverCount"
    ]
};
</script>
